/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
/*
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-01-15 19:30:58
 * @LastEditTime: 2019-08-12 16:05:55
 */

/**
 * Created by WJX on 2017/11/2.
 */


import store from '@/store/index';

var Api = /*#__PURE__*/function () {
  function Api() {
    _classCallCheck(this, Api);
  }

  _createClass(Api, [{
    key: "setStorage",
    value: function setStorage(keys, val) {
      //设置缓存
      var values = val;

      if (_typeof(val) == 'object') {
        values = JSON.stringify(val);
      }

      sessionStorage.setItem(keys, values);
    }
  }, {
    key: "getStorage",
    value: function getStorage(keys) {
      //获取缓存
      if (!sessionStorage.getItem(keys)) {
        return null;
      }

      try {
        return JSON.parse(sessionStorage.getItem(keys));
      } catch (e) {
        return sessionStorage.getItem(keys);
      }
    }
  }, {
    key: "setUserId",
    value: function setUserId(id) {
      localStorage.setItem('wxUserId', id);
    }
  }, {
    key: "getUserId",
    value: function getUserId() {
      return localStorage.getItem('wxUserId') || '';
    }
    /*
     * 设置缓存与store
     * */

  }, {
    key: "setVuexStorage",
    value: function setVuexStorage(data) {
      this.setStorage('wxUserInfo', data);
      store.dispatch('wxUserInfoAction', data);
    }
    /*
     * 微信中的不同内核
     * */

  }, {
    key: "kernel",
    value: function kernel() {
      var ua = navigator.userAgent.toLowerCase();

      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return 'wx';
      } else {
        if (/android/.test(ua)) {
          return 'android';
        } else if (/iphone|ipad|ipod/.test(ua)) {
          return 'ios';
        } else {
          return 'pc';
        }
      }
    } //过滤学科分类 多个是上传一个

  }, {
    key: "categoriesFilter",
    value: function categoriesFilter(categories) {
      var arr = [{
        categoryName: '',
        id: ''
      }, {
        categoryName: '',
        id: ''
      }];

      if (categories) {
        categories.forEach(function (item) {
          if (item.categoryLevel == 1 && !arr[0].categoryName) {
            arr[0] = item;
          } else if (item.categoryLevel == 2 && !arr[1].categoryName) {
            arr[1] = item;
          }
        });
      }

      store.commit('CHANGE_categoriesList', arr);
      return arr;
    }
    /*
     * IOS内核
     * */

  }, {
    key: "ios",
    value: function ios() {
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) return true;
      return false;
    }
    /*
     * kln userAgent
     * */

  }, {
    key: "isKln",
    value: function isKln() {
      if (/kln_android/.test(navigator.userAgent)) {
        return 'kln_android';
      } else if (/kln_ios/.test(navigator.userAgent)) {
        return 'kln_ios';
      } else {
        return false;
      }
    } //改变原生TITLE

  }, {
    key: "nativeEvent",
    value: function nativeEvent(names) {
      var appHeaderName = names;

      if (appHeaderName == '医学V视界') {
        appHeaderName = '学术天地';
      } else if (appHeaderName == '专区') {
        appHeaderName = '学术专区';
      }

      if (this.isKln() == 'kln_ios') {
        window.webkit.messageHandlers.doSomething.postMessage({
          titleName: appHeaderName
        });
      } else if (this.isKln() == 'kln_android') {
        window.doSomething.titleName(appHeaderName);
      }
    } // KLN android 专区 原生返回按钮是否显示

  }, {
    key: "showNativeBack",
    value: function showNativeBack(arg) {
      if (this.isKln() == 'kln_android') {
        window.doSomething.showBack(arg);
      }
    }
    /*
     * 手机号验证
     * */

  }, {
    key: "regPhone",
    value: function regPhone(phone) {
      var phoneReg = /^1\d{10}$/;

      if (phoneReg.test(phone)) {
        return true;
      } else {
        return false;
      }
    }
    /*
     * 添加query时判断 ？ 或者 &
     * */

  }, {
    key: "prefixQuery",
    value: function prefixQuery(argUrl) {
      // let formatUrl =  this.infoWxShareUrl()
      if (argUrl.split('?').length > 1) {
        return '&';
      } else {
        return '?';
      }
    }
    /*
     * 格式化微信分享后的URL 去除分享后微信添加的标识
     * */

  }, {
    key: "infoWxShareUrl",
    value: function infoWxShareUrl() {
      var shareUrl = location.href;

      if (/\.html\?from\=/.test(shareUrl)) {
        var infoUrl = shareUrl.split('?')[1].split('#')[0];
        var formatReg = new RegExp(infoUrl);
        return shareUrl.replace(formatReg, '').replace(/\?/, '');
      } else {
        return shareUrl;
      }
    }
    /*
     * 初始化神测数据
     * */
    // TODO:  神策改版后删除

  }, {
    key: "infoSC",
    value: function infoSC(storageObj) {
      if (!storageObj) {
        sa.identify('', true);
      } else {
        if (!storageObj.phone) {
          sa.identify(storageObj.wxOpenId, true);
        } else {
          //sa.store.getDistinctId() 获取identify
          sa.login(storageObj.id);
        }
      }
    }
  }]);

  return Api;
}();

export { Api as default };